import {
  FormControl,
  FormControlLabel,
  InputLabel,
  ListSubheader,
  Radio,
  RadioGroup,
  Select,
  Stack,
} from "@mui/material";
import React, { useState } from "react";
import { locale } from "../../utils/LocaleManager";
import { styled } from "@mui/system";
import { useContentStore } from "../../stores/contentStore";

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  margin: "0 0 0 0.75rem",
  gap: "16px",
  "& .MuiFormControlLabel-label": {
    fontFamily: "Inter",
    fontWeight: "500",
    fontSize: "16px",
  },
}));

const StyledStack = styled(Stack)(({ theme }) => ({
  borderRadius: "0.5rem",
  padding: "0.25rem",
  gap: "0.6rem",
  alignItems: "center",
  justifyContent: "space-between",
  margin: "0 0 0 2rem",
  width: "15.6rem",
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: theme.palette.primary.main,
    },
    "&:hover fieldset": {
      borderColor: theme.palette.primary.dark,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.primary.light,
    },
  },
}));

const RadioOption = ({ value, label, groupName, handleClick }: any) => (
  <StyledFormControlLabel
    value={value}
    control={<Radio />}
    label={label}
    onClick={(event) => handleClick(value, groupName, label)}
  />
);

const SortFilter = () => {
  const { setSortOrder, setSortField } = useContentStore((state: any) => ({
    setSortOrder: state.setSortOrder,
    setSortField: state.setSortField,
  }));

  const [selectedOption, setSelectedOption] = useState("");
  const [radioValue, setRadioValue] = useState("title-0");

  const handleClick = (value: any, groupName: string, label: string) => {
    const getValue = value.split("-")[1];
    setSortField(groupName);
    setSortOrder(getValue);
    setSelectedOption(label);
    setRadioValue(value);
  };

  return (
    <StyledStack direction="row">
      <FormControl fullWidth>
        <InputLabel id="select-label" style={{ background: "white" }}>
          {locale.displaySort}
        </InputLabel>
        <StyledSelect
          labelId="select-label"
          id="select"
          value={selectedOption}
          label="SortFilter"
          renderValue={(selected: any) =>
            selected ? selected : "Select an option"
          }
        >
          <RadioGroup
            name="radiogroup"
            value={radioValue}
            defaultValue={radioValue}
          >
            <ListSubheader>{locale.filter_category_alphabetical}</ListSubheader>
            <RadioOption
              value="title-0"
              label="A-Z"
              groupName="title"
              handleClick={handleClick}
            />
            <RadioOption
              value="title-1"
              label="Z-A"
              groupName="title"
              handleClick={handleClick}
            />
            <ListSubheader>{locale.filter_category_videoLength}</ListSubheader>
            <RadioOption
              value="videolength-0"
              label="Short to Long"
              groupName="videolength"
              handleClick={handleClick}
            />
            <RadioOption
              value="videolength-1"
              label="Long to Short"
              groupName="videolength"
              handleClick={handleClick}
            />
            <ListSubheader>{locale.filter_category_dateModified}</ListSubheader>
            <RadioOption
              value="datemodified-0"
              label="Oldest to Newest"
              groupName="datemodified"
              handleClick={handleClick}
            />
            <RadioOption
              value="datemodified-1"
              label="Newest to Oldest"
              groupName="datemodified"
              handleClick={handleClick}
            />
            <ListSubheader>{locale.filter_category_dateCreated}</ListSubheader>
            <RadioOption
              value="datecreated-0"
              label="Oldest to Newest"
              groupName="datecreated"
              handleClick={handleClick}
            />
            <RadioOption
              value="datecreated-1"
              label="Newest to Oldest"
              groupName="datecreated"
              handleClick={handleClick}
            />
          </RadioGroup>
        </StyledSelect>
      </FormControl>
    </StyledStack>
  );
};

export default SortFilter;
